exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggest[data-v-7824f32e]{margin-bottom:1.25rem}.suggest[data-v-7824f32e],.suggest__wrapper[data-v-7824f32e]{display:flex;flex-direction:column;width:100%;position:relative}.suggest__wrapper .dropdown[data-v-7824f32e]{position:absolute;bottom:0;left:0;transform:translateY(100%)}.suggest.hide-error .error[data-v-7824f32e]{display:none}", ""]);

// exports
